import React from "react";

import giphy from "assets/images/gah/giphy.png";
import footerLogo from "assets/images/gah/footer-logo.png";

const GAHFooter = ({ toggleGiphyModal }) => {
  return (
    <div className="gah-footer">
      <img alt="" src={footerLogo} className="logo" />
      <img
        alt=""
        src={giphy}
        className="giphy-logo"
        onClick={toggleGiphyModal}
      />
    </div>
  );
};

export default GAHFooter;
